import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { CircularProgress, Stack, styled } from "@mui/material";

const FullPage = styled(Stack)(() => ({
	height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
}));

export default function AuthCheck() {
	const navigate = useNavigate();
	const { currentUser, isLoading } = useAuth();

	if (isLoading) {
		return (
			<FullPage sx={{
				justifyContent: "center",
				alignItems: "center",
			}}>
				<CircularProgress />
			</FullPage>
		);
	}
	else if (currentUser === null) {
		navigate("/login");
	}

	return (
		<>
			<Outlet></Outlet>
		</>
	)
}; 